var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "outerPhotoContainer", staticClass: "outer-photo-container" },
    [
      _c(
        "div",
        { staticClass: "icon-container" },
        [
          _vm.image
            ? [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    attrs: {
                      "data-toggle": "modal",
                      "data-target": "#modal-delete-" + _vm.index,
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-trash fa-2x",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.handleDownloadMarketingPhoto },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-cloud-download fa-2x",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ]
            : [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.handleGetFileInput },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-plus fa-2x",
                      attrs: { "aria-hidden": "true" },
                    }),
                  ]
                ),
              ],
        ],
        2
      ),
      _vm._v(" "),
      _c("input", {
        ref: "fileInput",
        attrs: {
          type: "file",
          id: "imageUrl_" + _vm.index,
          name: "marketingPhoto",
        },
        on: { change: _vm.handleAddMarketingPhoto },
      }),
      _vm._v(" "),
      _c("div", {
        staticClass: "photo-container",
        style: { backgroundImage: "url(" + _vm.photo.file_url + ")" },
      }),
      _vm._v(" "),
      _c("talent-delete-photo-modal", {
        attrs: { idKey: _vm.index },
        on: { deletePhoto: _vm.handleDeleteMarketingPhoto },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }